import React from "react";
import "./Collections.scss";
import {
    MDBCol,
    MDBContainer,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBRow
} from "mdbreact";
import TopNavSubpage from "../../component/TopNav/TopNavSubpage";
import {Zoom } from 'react-reveal'
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import AllCollectionsQuery from "../../queries/AllCollectionsQuery";
import {assetUrl} from "../../serviceApi";

const CoinIcon = assetUrl+"images/coin.svg";
const ShieldIcon = assetUrl+"images/shield.svg";
const BagIcon = assetUrl+"images/bag_coin.svg";
const DiamondIcon = assetUrl+"images/diamond.svg";
const FacebookIcon = assetUrl+"images/facebook.svg";
const InstagramIcon = assetUrl+"images/instagram.svg";
const TwitterIcon = assetUrl+"images/twitter.svg";
const GiftPaper = assetUrl+"images/gift-paper.png";

class Collections extends React.Component {
    state = {
        collections: [
            {
                src: CoinIcon,
                title: "Lorem"
            },
            {
                src: ShieldIcon,
                title: "Lorem"
            },
            {
                src: BagIcon,
                title: "Lorem"
            },
            {
                src: ShieldIcon,
                title: "Lorem"
            },
            {
                src: DiamondIcon,
                title: "Lorem"
            },
            {
                src: CoinIcon,
                title: "Lorem"
            },
            {
                src: CoinIcon,
                title: "Lorem"
            },
            {
                src: ShieldIcon,
                title: "Lorem"
            },
            {
                src: BagIcon,
                title: "Lorem"
            },
            {
                src: ShieldIcon,
                title: "Lorem"
            },
            {
                src: DiamondIcon,
                title: "Lorem"
            },
            {
                src: CoinIcon,
                title: "Lorem"
            },
        ],
        modal: false,
        loading:false
    }
    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    }

    componentDidMount() {
        // this.getAllCollections();
    }
    getAllCollections = () => {
        let variables = {}
        this.updateLoading(true);
        fetchQuery(environment, AllCollectionsQuery, variables)
            .toPromise()
            .then(response => {
                this.updateLoading(false);
                if (response.allCollections !== null && response.allCollections.edges.length > 0) {
                    this.setState({
                        collections: response.allCollections.edges
                    })
                }else {
                    this.setState({
                        collections: []
                    })
                }
            }, err => {
                this.updateLoading(false);
                console.log(err);
                this.setState({
                    stocksInNews: []
                })
            });
    }

    updateLoading = (action) => {

        this.setState({
            loading:action
        })
    }
    render() {
        return (
            <MDBContainer className="collections-component pb-4">
                {/*<SubPageHeader title="My Collections" show_action={false}/>*/}
                <TopNavSubpage heading={"My Collections"} notify={false} wallet={false} border={true}/>

                <MDBContainer>
                    <MDBRow className={"my-2"}>
                        {
                            this.state.collections.map((item, index) => {
                                return (
                                    <MDBCol size={"4"} key={index} className="my-2">
                                        <Zoom>
                                            <div className="text-center" onClick={this.toggle}>
                                                <img src={item.src} alt="italic_image"
                                                     className="img-fluid mb-2"/>
                                                <p className="collection-name my-1">{item.title}</p>
                                            </div>
                                        </Zoom>

                                    </MDBCol>
                                );
                            })
                        }
                    </MDBRow>
                </MDBContainer>
                <MDBModal isOpen={this.state.modal} toggle={this.toggle} fullHeight position="bottom">
                    <MDBModalHeader toggle={this.toggle}>
                        Share with Friends
                    </MDBModalHeader>
                    <MDBModalBody>
                        <div className="container">
                            <div className="text-center">
                                <div className="selected-collection">
                                    <img src={BagIcon} alt="italic_image"
                                         className="img-fluid my-3"/>
                                    <img src={GiftPaper} alt="GiftPaper" className="img-fluid gift-paper"/>
                                </div>
                                <p className="modal-collection-name ">Lorem Ipsum dolor sit
                                    amet</p>
                                <p className="collection-description ">Lorem ipsum dolor sit amet,
                                    consectetur adipiscing
                                    elit. Amet facilisis aenean metus gravida sit. Enim, metus </p>
                                <br/>
                                <p className="share-content">Share with your Friends:</p>
                            </div>
                            <div className="d-flex justify-content-center align-items-center">
                                <img src={FacebookIcon} alt="italic_image"
                                     className="img-fluid my-1 mx-2"/>
                                <img src={TwitterIcon} alt="italic_image"
                                     className="img-fluid my-1 mx-2"/>
                                <img src={InstagramIcon} alt="italic_image"
                                     className="img-fluid my-1 mx-2"/>
                            </div>
                        </div>

                    </MDBModalBody>
                </MDBModal>
            </MDBContainer>
        );
    }
}

export default Collections;